//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  postFakeLogin,
  postJwtLogin,
  postSocialLogin,
  postGoogleLogin,
} from "../../../helpers/fakebackend_helper";

import { loginSuccess, logoutUserSuccess, apiError, reset_login_flag } from './reducer';
import { setAuthorization } from "../../../helpers/api_helper";

export const loginUser = (user, history) => async (dispatch) => {
  try {
    let response;

    response = postFakeLogin({
      email: user.email,
      password: user.password,
    });

    var data = await response;
    console.log(data)
    if (data.success) {
      // console.log(JSON.stringify(data.data))
      localStorage.setItem("authUser", JSON.stringify(data.data));
      setAuthorization()
      dispatch(loginSuccess(data.data));
      history('/dashboard')

    } else {
      dispatch(apiError({data: data.message}));
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const logoutUser = () => async (dispatch) => {
  try {
    localStorage.removeItem("authUser");
    let fireBaseBackend = getFirebaseBackend();
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = fireBaseBackend.logout;
      dispatch(logoutUserSuccess(response));
    } else {
      dispatch(logoutUserSuccess(true));
    }

  } catch (error) {
    dispatch(apiError(error));
  }
};

export const socialLogin = (type, history) => async (dispatch) => {
  try {
    let response;

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend();
      response = fireBaseBackend.socialLoginUser(type);
    }
    //  else {
    //   response = postSocialLogin(data);
    // }

    const socialdata = await response;
    if (socialdata) {
      localStorage.setItem("authUser", JSON.stringify(response));
      dispatch(loginSuccess(response));
      history('/dashboard')
    }

  } catch (error) {
    dispatch(apiError(error));
  }
};

export const loginWithGoogle = (accessToken, history) => async (dispatch) => {
  try {
    const data = await postGoogleLogin(accessToken);
    if (data && data.success) {
      localStorage.setItem("authUser", JSON.stringify(data.data));
      setAuthorization();
      dispatch(loginSuccess(data.data));
      history('/dashboard');
    } else {
      const msg = (data && data.message) || "Failed to sign in with Google.";
      dispatch(apiError({ data: msg }));
    }
  } catch (error) {
    const msg = (typeof error === "string" && error)
      || (error && error.message)
      || "Failed to sign in with Google.";
    dispatch(apiError({ data: msg }));
  }
};

export const resetLoginFlag = () => async (dispatch) => {
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error) {
    dispatch(apiError(error));
  }
};